import {Button, Dialog, DialogActions, DialogContent, DialogTitle, List, ListItemButton, ListItemText} from "@mui/material";
import React from "react";
import {useSupplierCategories} from "./SupplierContext";
import {ProjectSupplierCategory} from "../../../../api/SupplierCategories";

export function BulkUpdateSuppliedBy(props: {
    name: string;
    onClose(): void;
    onSelect(supplier: ProjectSupplierCategory): void;
}) {
    const suppliers = useSupplierCategories();

    return (
        <Dialog open onClose={props.onClose} fullWidth maxWidth="xs">
            <DialogTitle>Update Supplied By for Group {props.name}</DialogTitle>
            <DialogContent dividers style={{paddingLeft: 0, paddingRight: 0}}>
                <List disablePadding>
                    {suppliers.list?.filter(s => s.parent === null).sort((a, b) => a.sortOrder - b.sortOrder).map(s => (
                        <ListItemButton key={s.id} onClick={() => props.onSelect(s)}>
                            <ListItemText primary={s.name} />
                        </ListItemButton>
                    ))}
                </List>
            </DialogContent>
            <DialogActions>
                <Button onClick={props.onClose}>Cancel</Button>
            </DialogActions>
        </Dialog>
    )
}
